import React, { useState } from "react";
import "./AdminPanel.css"; // Import the CSS file

const AdminPanel = () => {
  const [companyName, setCompanyName] = useState("");
  const [apiToken, setApiToken] = useState("");
  const [requiredDays, setRequiredDays] = useState("");
  const [hrEmail, setHrEmail] = useState("");
  const [pdfTitles, setPdfTitles] = useState({
    firstPeriod: "DENEME SURESI DEGERLENDIRME FORMU",
    secondPeriod: "DENEME SURESI DEGERLENDIRME FORMU"
  });
  const [formUrls, setFormUrls] = useState({
    firstPeriodEmployee: "",
    firstPeriodManager: "",
    secondPeriodEmployee: "",
    secondPeriodManager: "",
  });
  const [uploadOptions, setUploadOptions] = useState({
    uploadToManager: false,
    uploadToSecondManager: false,
    uploadManagerForm: false,
    uploadSecondManagerForm: false,
    uploadManagerFormToEmployee: false,
    uploadEmployeeFormToEmployee: false,
  });
  const [reminderSettings, setReminderSettings] = useState({
    firstReminderDay: 3,
    secondReminderDay: 7,
    thirdReminderDay: 14,
    enableReminders: true,
  });
  // Logo states removed for simplicity

  const handleFormUrlChange = (field) => (event) => {
    setFormUrls((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handlePdfTitleChange = (period) => (event) => {
    setPdfTitles((prev) => ({
      ...prev,
      [period]: event.target.value,
    }));
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setUploadOptions((prevOptions) => ({
      ...prevOptions,
      [name]: checked,
    }));
  };

  const handleReminderChange = (field) => (event) => {
    const value =
      field === "enableReminders"
        ? event.target.checked
        : parseInt(event.target.value);
    setReminderSettings((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Logo handling removed for simplicity

  const handleSubmit = (event) => {
    event.preventDefault();

    // Validate that at least one form URL is provided
    const hasAnyFormUrl =
      formUrls.firstPeriodEmployee ||
      formUrls.firstPeriodManager ||
      formUrls.secondPeriodEmployee ||
      formUrls.secondPeriodManager;

    if (!hasAnyFormUrl) {
      alert("Please provide at least one form URL (employee or manager form).");
      return;
    }

    // Create JSON payload (no file upload)
    const payload = {
      companyName,
      apiToken,
      requiredDays,
      hrEmail,
      pdfTitles,
      formUrls,
      uploadOptions,
      reminderSettings,
    };

    fetch(
      `${
        process.env.REACT_APP_API_URL || "http://localhost:5001"
      }/api/employees/create-integration`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("Data from server:", data);
        alert(data.message);

        // Reset form on success
        if (data.success !== false) {
          setCompanyName("");
          setApiToken("");
          setRequiredDays("");
          setHrEmail("");
          setPdfTitles({
            firstPeriod: "DENEME SURESI DEGERLENDIRME FORMU",
            secondPeriod: "DENEME SURESI DEGERLENDIRME FORMU"
          });
          setFormUrls({
            firstPeriodEmployee: "",
            firstPeriodManager: "",
            secondPeriodEmployee: "",
            secondPeriodManager: "",
          });
          setUploadOptions({
            uploadToManager: false,
            uploadToSecondManager: false,
            uploadManagerForm: false,
            uploadSecondManagerForm: false,
            uploadManagerFormToEmployee: false,
          });
          setReminderSettings({
            firstReminderDay: 3,
            secondReminderDay: 7,
            thirdReminderDay: 14,
            enableReminders: true,
          });
          // Logo states removed
        }
      })
      .catch((error) => {
        console.error("Error in fetch operation:", error);
        alert(
          "Failed to create integration. Please check console for details."
        );
      });
  };

  return (
    <div className="admin-panel">
      <div className="panel-card">
        <h1 className="panel-title">Create New Integration</h1>

        <form onSubmit={handleSubmit}>
          <div className="form-section">
            <h2 className="form-section-title">Basic Information</h2>
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Company Name</label>
                <input
                  type="text"
                  className="form-input"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  placeholder="Enter company name"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">API Token</label>
                <input
                  type="text"
                  className="form-input"
                  value={apiToken}
                  onChange={(e) => setApiToken(e.target.value)}
                  placeholder="Enter Kolayik API token"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Required Days</label>
                <input
                  type="text"
                  className="form-input"
                  value={requiredDays}
                  onChange={(e) => setRequiredDays(e.target.value)}
                  placeholder="e.g., 30, 60, 90"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">HR Contact Email</label>
                <input
                  type="email"
                  className="form-input"
                  value={hrEmail}
                  onChange={(e) => setHrEmail(e.target.value)}
                  placeholder="hr@company.com"
                  required
                />
              </div>

               {/* Logo upload removed for simplicity */}
            </div>
          </div>

          <div className="form-section">
            <h2 className="form-section-title">PDF Report Titles</h2>
            <p className="form-help-text" style={{ marginBottom: '20px', color: '#666' }}>
              Set different titles for each evaluation period (e.g., "2. AY DEĞERLENDİRME FORMU SONUÇLARI" for first period, "6. AY DEĞERLENDİRME FORMU SONUÇLARI" for second period)
            </p>
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">First Period PDF Title</label>
                <input
                  type="text"
                  className="form-input"
                  value={pdfTitles.firstPeriod}
                  onChange={handlePdfTitleChange('firstPeriod')}
                  placeholder="e.g., 2. AY DEĞERLENDİRME FORMU SONUÇLARI"
                  required
                />
                <small style={{ color: '#666', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                  For first period forms (e.g., 30 days)
                </small>
              </div>

              <div className="form-group">
                <label className="form-label">Second Period PDF Title</label>
                <input
                  type="text"
                  className="form-input"
                  value={pdfTitles.secondPeriod}
                  onChange={handlePdfTitleChange('secondPeriod')}
                  placeholder="e.g., 6. AY DEĞERLENDİRME FORMU SONUÇLARI"
                  required
                />
                <small style={{ color: '#666', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                  For second period forms (e.g., 60 days)
                </small>
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2 className="form-section-title">Form URLs</h2>
            <p
              className="form-help-text"
              style={{ marginBottom: "20px", color: "#666", fontSize: "14px" }}
            >
              You can provide either employee forms, manager forms, or both.
              Leave fields empty if you don't want to use that type of form.
            </p>
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">First Period Employee Form</label>
                <input
                  type="url"
                  className="form-input"
                  value={formUrls.firstPeriodEmployee}
                  onChange={handleFormUrlChange("firstPeriodEmployee")}
                  placeholder="https://form.typeform.com/to/your-form-id (optional)"
                />
              </div>

              <div className="form-group">
                <label className="form-label">First Period Manager Form</label>
                <input
                  type="url"
                  className="form-input"
                  value={formUrls.firstPeriodManager}
                  onChange={handleFormUrlChange("firstPeriodManager")}
                  placeholder="https://form.typeform.com/to/your-form-id (optional)"
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  Second Period Employee Form
                </label>
                <input
                  type="url"
                  className="form-input"
                  value={formUrls.secondPeriodEmployee}
                  onChange={handleFormUrlChange("secondPeriodEmployee")}
                  placeholder="https://form.typeform.com/to/your-form-id (optional)"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Second Period Manager Form</label>
                <input
                  type="url"
                  className="form-input"
                  value={formUrls.secondPeriodManager}
                  onChange={handleFormUrlChange("secondPeriodManager")}
                  placeholder="https://form.typeform.com/to/your-form-id (optional)"
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <div className="upload-options">
              <h3 className="upload-options-title">Upload Configuration</h3>
              <div className="checkbox-group">
                <label className="form-checkbox-label">
                  <input
                    type="checkbox"
                    className="form-checkbox"
                    name="uploadToManager"
                    checked={uploadOptions.uploadToManager}
                    onChange={handleCheckboxChange}
                  />
                  Upload Employee Form to Manager
                </label>
                <label className="form-checkbox-label">
                  <input
                    type="checkbox"
                    className="form-checkbox"
                    name="uploadEmployeeFormToEmployee"
                    checked={uploadOptions.uploadEmployeeFormToEmployee}
                    onChange={handleCheckboxChange}
                  />
                  Upload Employee Form to Employee
                </label>
                <label className="form-checkbox-label">
                  <input
                    type="checkbox"
                    className="form-checkbox"
                    name="uploadToSecondManager"
                    checked={uploadOptions.uploadToSecondManager}
                    onChange={handleCheckboxChange}
                  />
                  Upload Employee Form to Second Manager
                </label>
                <label className="form-checkbox-label">
                  <input
                    type="checkbox"
                    className="form-checkbox"
                    name="uploadManagerForm"
                    checked={uploadOptions.uploadManagerForm}
                    onChange={handleCheckboxChange}
                  />
                  Upload Manager Form to Manager
                </label>
                <label className="form-checkbox-label">
                  <input
                    type="checkbox"
                    className="form-checkbox"
                    name="uploadSecondManagerForm"
                    checked={uploadOptions.uploadSecondManagerForm}
                    onChange={handleCheckboxChange}
                  />
                  Upload Manager Form to Second Manager
                </label>
                <label className="form-checkbox-label form-grid-full">
                  <input
                    type="checkbox"
                    className="form-checkbox"
                    name="uploadManagerFormToEmployee"
                    checked={uploadOptions.uploadManagerFormToEmployee}
                    onChange={handleCheckboxChange}
                  />
                  Upload Manager Form to Employee
                </label>
              </div>
            </div>
          </div>

          <div className="form-section">
            <div className="upload-options">
              <h3 className="upload-options-title">Email Reminder Settings</h3>
              <div className="form-grid">
                <label className="form-checkbox-label form-grid-full">
                  <input
                    type="checkbox"
                    className="form-checkbox"
                    checked={reminderSettings.enableReminders}
                    onChange={handleReminderChange("enableReminders")}
                  />
                  Enable Email Reminders
                </label>

                {reminderSettings.enableReminders && (
                  <>
                    <div className="form-group">
                      <label className="form-label">
                        1st Reminder (days after form sent)
                      </label>
                      <input
                        type="number"
                        className="form-input"
                        value={reminderSettings.firstReminderDay}
                        onChange={handleReminderChange("firstReminderDay")}
                        min="1"
                        max="30"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        2nd Reminder (days after form sent)
                      </label>
                      <input
                        type="number"
                        className="form-input"
                        value={reminderSettings.secondReminderDay}
                        onChange={handleReminderChange("secondReminderDay")}
                        min="1"
                        max="30"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        3rd Reminder (days after form sent)
                      </label>
                      <input
                        type="number"
                        className="form-input"
                        value={reminderSettings.thirdReminderDay}
                        onChange={handleReminderChange("thirdReminderDay")}
                        min="1"
                        max="30"
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn btn-primary btn-lg">
              Create Integration
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminPanel;
